<template>
	<div class="centerWidth">
		<div class="gaokao-nav">
			<span @click="goMyCenter">个人中心 ></span>
			<span>同分数考生去向</span>
		</div>
		<section class="gaokao-content">
			<div style="overflow: hidden;">
				<div class="my-title ">同分数考生去向</div>
				<h6 class="qxH6">{{ Name }}-{{ typeId }}.考试{{ score }}分录取情况</h6>
				<div class="go flex zhong float">
					<p>*本数据不含加分、包括自主招生及专项招生计划等信息</p>
					<button type="button" @click="goReturn()">继续查询</button>
				</div>
				<article class="table xiaoDiv">
					<hgroup class="flex">
						<p>年份</p>
						<p>院校名称</p>
						<p>科类</p>
						<p>批次</p>
						<p>最低分</p>
					</hgroup>
					<ul>
						<li class="flex" v-for="(item, index) in list" :key="index">
							<p>{{ item.Year }}</p>
							<p>{{ item.CollegesName }}</p>
							<p>{{ item.CandidatesType }}</p>
							<p>{{ item.AdmissionBatch }}</p>
							<p>{{ item.LowestScore }}</p>
						</li>
					</ul>
					<div class="flex xend major-page" style="margin: 20px auto;" v-if="list.length > 0">
						<el-pagination background layout="prev, pager, next" :page-size="size" @current-change="GetPageList" :current-page="page" :total="totleNum"></el-pagination>
					</div>
				</article>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	data() {
		return {
			cityName: '',
			Name: '',
			typeId: '',
			score: '',
			list: [],
			page: 1,
			size: 10,
			totleNum: 0
		};
	},
	// 加载
	created() {
		console.log(this.$route.query);
		this.cityName = this.$route.query.cityName;
		this.Name = this.$route.query.Name;
		this.typeId = this.$route.query.typeId;
		this.score = this.$route.query.score;
		this.AdmissionRiskAssessment(1);
	},
	methods: {
		// 个人中心
		goMyCenter() {
			this.$router.push('/myIndex');
		},

		AdmissionRiskAssessment(page) {
			var that = this;

			var data = {
				page: page,
				size: 10,
				cityCode: that.cityName,
				candidatesType: that.typeId,
				score: that.score,
				name: ''
			};
			console.log(data);
			that.$api.HtppRequest(
				'SystemData/AdmissionLineList',
				'POST',
				data,
				function(res) {
					console.log('获取列表', res);

					if (res.flag && res.totle > 0) {
						var list = res.list;

						that.totleNum = res.totle;

						if (page === 1) {
							that.list = [];
						}
						if (list.length > 0) {
							that.page = page;
							for (var i = 0; i < list.length; i++) {
								that.list.push(list[i]);
							}
						}

						console.log(that.list);
					}
				},
				function(err) {
					console.log(err);
				}
			);
		},
		// 获取其他页
		GetPageList: function(val) {
			var that = this;
			that.AdmissionRiskAssessment(val);
		},
		goReturn() {
			this.$router.push('/lastGo?key=Whereabout');
		}
	}
};
</script>

<style scoped>
.go button {
	font-size: 14px;
	color: #fff;
	border-radius: 4px;
	background-color: #333;
	display: block;
	text-align: center;
	width: 80px;
	height: 40px;
	line-height: 40px;
	cursor: pointer;
}

.go p {
	font-size: 14px;
	color: #f59a23;
	margin-left: 25px;
}

.go {
	margin: 30px 0;
}

.qxH6 {
	overflow: hidden;
	background-color: #eaeaea;
	font-size: 16px;
	color: #333;
	text-align: center;
	height: 60px;
	line-height: 60px;
	font-weight: normal;
}

.xiaoDiv li p {
	width: 20% !important;
}

.xiaoDiv hgroup p {
	width: 20% !important;
}

.table li p {
	font-size: 14px;
	width: calc(100% / 6);
	line-height: 60px;
	text-align: center;
}

.table li:last-child {
	border-bottom: none;
}

.table li p:last-child {
	border-right: none;
}

.table li {
	border-bottom: solid 1px #e6e6e6;
}

.table ul {
	overflow: hidden;
}

.table hgroup p {
	font-size: 14px;
	background-color: #eaeaea;
	width: calc(100% / 6);
	line-height: 60px;
	text-align: center;
}

.table {
	overflow: hidden;
	border: solid 1px #e6e6e6;
	box-sizing: border-box;
	margin-top: 30px;
}

/* 01 */
.fenNum_div p {
	width: 78px;
	height: 40px;
	line-height: 40px;
	float: left;
	color: #333;
	font-size: 14px;
	margin-right: 20px;
	text-align: center;
	border-radius: 4px;
	cursor: pointer;
}

.fenNum_div p:hover {
	opacity: 0.7;
}

.fenNum_div p.on:hover {
	opacity: 1;
}

.fenNum_div p.on {
	background-color: #333;
	color: #fff;
}

.fenNum_div {
	width: calc(100% - 200px);
	margin-left: 20px;
}

.major-share label {
	font-size: 14px;
	color: #333;
	display: block;
	width: 100px;
	line-height: 40px;
	text-align: right;
}

.major-share ul li:first-child {
	margin-top: 0;
}

.major-share ul li {
	margin-top: 10px;
}

.major-share ul {
	overflow: hidden;
}

/* major-share */

.gaokao-btn {
	width: 90px;
	font-size: 14px;
	margin-left: 0 !important;
}

/* fenNum_head */

.gaokao-nav {
	width: 100%;
	display: flex;
	align-items: center;
	padding: 20px 0;
}
.gaokao-nav span {
	font-size: 15px;
	color: #333;
}
.gaokao-nav span:last-child {
	color: #333;
}
/* gaokao-content */
.gaokao-content {
	padding: 0 20px;
	width: 100%;
	height: auto;
	overflow: hidden;
	background-color: #fff;
	margin-bottom: 25px;
	padding-bottom: 60px;
}
/* major-share */
.major-share {
	width: 100%;
	height: auto;
	overflow: hidden;
	background-color: #eaeaea;
	margin: 20px auto 30px auto;
	padding: 30px 0;
}
.major-share-con {
	width: 75%;
	height: auto;
	overflow: ;
	display: flex;
	flex-wrap: wrap;
}
.share-li {
	width: 50%;
	display: flex;
	align-items: center;
	/* justify-content: center; */
	margin: 10px 0;
}

.share-li p {
	font-size: 14px;
	color: #333;
	width: 100px;
	text-align: right;
	margin-right: 20px;
}
.share-li input {
	width: 270px;
	height: 40px;
	line-height: 40px;
	padding: 0 10px;
	display: block;
	border-radius: 5px;
	background-color: #fff;
	color: #333;
	font-size: 14px;
}
.share-li input::-webkit-input-placeholder {
	color: #999;
}
.share-li input:-moz-placeholder {
	color: #999;
}
.share-li input:-ms-input-placeholder {
	color: #999;
}

.sjWidth {
	width: 270px;
}
.major-btn01 {
	width: 25%;
	display: flex;
	align-items: flex-end;
}
.major-btn01 button {
	margin: 10px auto;
}
/* major-list */
.major-list {
	width: 100%;
	height: auto;
	margin-top: 15px;
}
.major-list ul {
	width: 100%;
	height: auto;
}
.major-list ul li {
	border: 1px solid #eee;
	width: 100%;
	height: auto;
	padding: 20px 30px;
	margin-bottom: 20px;
	position: relative;
}
.major-li01 {
	width: 100%;
	height: auto;
	display: flex;
	align-items: center;
}
.major-li-btn {
	width: 23%;
}
.major-li-btn p {
	width: 130px;
	height: 33px;
	line-height: 33px;
	text-align: center;
	background-color: #333;
	font-size: 16px;
	color: #fff;
	border-radius: 50px;
}
.major-li01-right {
	width: 80%;
	display: flex;
}
.major-li01-right p {
	width: 20%;
	display: flex;
	align-items: center;
	line-height: 33px;
}
.major-li01-right p span {
	font-size: 15px;
	color: #999;
}
.major-li01-right p span:last-child {
	color: #333;
}

.major-li02 {
	display: flex;
	align-items: center;
	margin-bottom: 10px;
}
.major-li02 p {
	font-size: 14px;
}
.major-txt01 {
	width: 75px;
	color: #999;
}
.major-txt02 {
	width: calc(100% - 120px);
	color: #333;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.major-more {
	width: 45px;
	color: #333;
	text-align: right;
	cursor: pointer;
}
.major-txt04 {
	color: #333;
}
.major-more-con {
	position: absolute;
	width: 98%;
	height: auto;
	background: rgba(0, 0, 0, 0.7);
	padding: 20px;
	font-size: 15px;
	color: #fff;
	left: 1%;
	bottom: 0;
	border-radius: 5px;
	margin-bottom: -14px;
	z-index: 1;
}
.major-more-con::after {
	position: absolute;
	content: '';
	right: 0;
	top: 0;
	width: 0;
	height: 0;
	border-left: 8px solid transparent;
	border-right: 8px solid transparent;
	border-bottom: 14px solid rgba(0, 0, 0, 0.7);
	margin-top: -14px;
	margin-right: 24px;
}
.major-page {
	margin-bottom: 30px;
}

.widthx {
	margin-top: 20px;
	margin-bottom: 10px;
}

.widthx .major-li01-right {
	width: 100%;
}

.widthx .major-li01-right p:first-child {
	min-width: 22.2%;
}

.widthx .major-li01-right p:nth-child(2) {
	width: 32.3%;
}

.lastIndex .major-li01-right p {
	width: 35%;
}
</style>
